<template>
  <div class="row">
    <div class="col-md-5">
      <card header-classes="bg-dark">
        <template slot="header">
          <h3 class="mb-0 text-white">สรุปข้อมูล</h3>
        </template>
        <template>
          <form @submit.prevent="fetchSummary">
            <div class="row">
              <div class="col-md-6">
                <base-input label="จาก">
                  <flat-picker
                    class="form-control datepicker"
                    v-model="start"
                  />
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input label="ถึง">
                  <flat-picker class="form-control datepicker" v-model="end" />
                </base-input>
              </div>
            </div>
            <base-button
              native-type="submit"
              type="default"
              :disabled="loading"
            >
              ดึงข้อมูล
            </base-button>
          </form>

          <div v-if="summary">
            <dl class="row pt-3">
              <dt class="col-md-5 mb-0">สรุปยอดฝาก</dt>
              <dd class="col-md-7 mb-0">
                {{ summary.depositTotal | format }} บาท
              </dd>
              <dt class="col-md-5 mb-0">สรุปยอดถอน <small>(สำเร็จ)</small></dt>
              <dd class="col-md-7 mb-0">
                {{ summary.withdrawTotal.success | format }} บาท
              </dd>
              <dt class="col-md-5 mb-0">
                สรุปยอดถอน <small>(ยกเลิกรายการ)</small>
              </dt>
              <dd class="col-md-7 mb-0">
                {{ summary.withdrawTotal.reject | format }} บาท
              </dd>
              <dt class="col-md-5 mb-0">
                สรุปกำไร <small>(ยอดฝาก - ยอดถอน)</small>
              </dt>
              <dd class="col-md-7 mb-0">
                {{
                  (summary.depositTotal - summary.withdrawTotal.success)
                    | format
                }}
                บาท
              </dd>

              <dt class="col-md-5 mb-0">สรุปยอดแนะนำเพื่อน</dt>
              <dd class="col-md-7 mb-0">
                {{ summary.affiliateTotal | format }} บาท
              </dd>
              <dt class="col-md-5 mb-0">สรุปยอดโบนัส</dt>
              <dd class="col-md-7 mb-0">
                {{ summary.promotionTotal | format }} บาท
              </dd>
              <dt class="col-md-5 mb-0">สรุปยอดโค๊ดโปรโมชั่น</dt>
              <dd class="col-md-7 mb-0">
                {{ summary.redeemTotal | format }} บาท
              </dd>
              <dt class="col-md-5 mb-0">สรุปยอดแคชแบ็ก</dt>
              <dd class="col-md-7 mb-0">
                {{ summary.cashbackTotal | format }} บาท
              </dd>
              <dt class="col-md-5 mb-0">สรุปยอดกงล้อเสี่ยงโชค</dt>
              <dd class="col-md-7 mb-0">
                {{ summary.wheelTotal | format }} บาท
              </dd>

              <dt class="col-md-5 mb-0">เปิดยูสเซอร์ใหม่</dt>
              <dd class="col-md-7 mb-0">
                {{ summary.memberCount | format(0) }}
              </dd>
              <dt class="col-md-5 mb-0">
                เปิดยูสเซอร์ใหม่ <small>(ฝากครั้งแรก)</small>
              </dt>
              <dd class="col-md-7 mb-0">
                {{ summary.memberFirstDepositCount | format(0) }}
              </dd>
            </dl>
          </div>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import flatPicker from "vue-flatpickr-component";

import moment from "moment";
import SummaryService from "../services/summary.service";

export default {
  components: {
    flatPicker,
  },
  data() {
    return {
      loading: false,
      start: moment().format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),
      summary: null,
    };
  },
  methods: {
    async fetchSummary() {
      this.loading = true;
      try {
        const res = await SummaryService.getSummary({
          start: this.start,
          end: this.end,
        });
        this.summary = res;
      } catch ({ message }) {
        this.$notify({ type: "danger", message });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
